import React from 'react'

import i18n from 'live/services/i18n'
import { SearchBar } from '@intelie/ui'

import { HeaderContainer, SearchBarSortAndFilter, Sort } from './raListHeaderStyles'
import { SortOptions } from './Sort/SortOptions'
import { SortOption } from '../Table/helper/helper'

interface RAListHeaderProps {
    searchTxt: string
    onChangeSearch: (searchTxt: string) => void
    selectedSorter: SortOption
    setSelectedSorter: (newSorter: SortOption) => void
}

export function RAListHeader({ searchTxt, onChangeSearch, selectedSorter, setSelectedSorter }: RAListHeaderProps) {
    return (
        <HeaderContainer>
            <SearchBarSortAndFilter>
                <SearchBar
                    className="reports-approval-search"
                    filteredValue={searchTxt}
                    placeholder={i18n('Search for a report approval')}
                    handleFilter={value => onChangeSearch(value)}
                    debounceWait={200}
                />
                <SortOptions selectedSorter={selectedSorter} setSelectedSorter={setSelectedSorter} />
            </SearchBarSortAndFilter>
        </HeaderContainer>
    )
}
